const DUPLICATE_ENTRY = 'DUPLICATE ENTRY' // This is a constant that is used to check if the error message contains the string 'DUPLICATE ENTRY'
export default {
  getErrorId (error) {
    let errorMessage = this.parseError(error)

    if (errorMessage.toUpperCase().includes(DUPLICATE_ENTRY)) {
      return DUPLICATE_ENTRY
    }
    return null
  },

  getErrorMessage (error) {
    let errorMessage = this.parseError(error)
    return new Error(errorMessage)
  },

  parseError (error) {
    let string

    if (error instanceof Error) {
      string = error.response?.data?.error?.exceptionDetails || error.message
    } else {
      string = error
    }

    return string
  }
}
